module.exports = __webpack_public_path__ + "static/img/pingpaiBiaozhi.3aebde7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/pingpaiBiaozhi.png
// module id = iaMP
// module chunks = 0